import React from 'react'
import About from './about'
import DeanMessage from './deanMessage'
import { DecodeHtml } from '../../utils/decodeHtml'
import { retrunAssets, returnNotImage } from '../../utils/getAssets'
import ShowCollegeSection from './showCollegeSection'

const AboutSection = ({ college }) => {
  const collegeManageHeader = college?.college_manage_header
  const data = college?.collegeManagement?.items?.map(d => {
    d = d?.content?.properties
    return {
      title: d?.title,
      info: DecodeHtml({ html: d?.description?.markup }),
      image: d?.photo ? retrunAssets(d?.photo[0]?.url) : returnNotImage()
    }
  })
  const collegeAdminHeader = college?.college_admin_header
  const adminData = college?.collegeAdmin?.items?.map(d => {
    d = d?.content?.properties
    return {
      title: d?.title,
      info: DecodeHtml({ html: d?.description?.markup }),
      image: d?.photo ? retrunAssets(d?.photo[0]?.url) : returnNotImage()
    }
  })

  return (
    <div className='flex flex-col gap-8'>
      <About college={college} />
      <DeanMessage college={college} />
      {college?.collegeBuildingDescription?.markup && (
        <div className='flex flex-col gap-5 p-4 md:px-10'>
          <h1 className='text-3xl font-bold '>About {college?.title}</h1>
          {DecodeHtml({ html: college?.collegeBuildingDescription?.markup })}
        </div>
      )}
     <ShowCollegeSection title={collegeManageHeader} data={data} />
     <ShowCollegeSection title={collegeAdminHeader} data={adminData} />
    </div>
  )
}

export default AboutSection
